export default "/fonts/Acrom-Light.ttf?af708a03b34e9623cb1516e8f4ab5702";